@if (statNbDoc === true) {
    <div class="margin">
      <div class="grid">
        <div class="col-1">
          <i class="pi pi-cog cursorPointer" pTooltip="{{'Param' | translate}}" (click)="overpanel.toggle($event)"></i>
        </div>
        <div class="col-11 align font-bold">
          {{ title }}
        </div>
      </div>
      <p-overlayPanel #overpanel>
        <div class="grid">
          <div class="col-12 md:col-6 lg:col-4">
            <div class="col-12 flex items-center">
              <p-radioButton
                name="group11"
                value="doughnut"
                [(ngModel)]="chartType"
                inputId="opt11"
              ></p-radioButton>
              <label for="opt11" class="ml-2">{{'doughnut' | translate}}</label>
            </div>
            <div class="col-12 flex items-center">
              <p-radioButton
                name="group11"
                value="pie"
                [(ngModel)]="chartType"
                inputId="opt21"
              ></p-radioButton>
              <label for="opt21" class="ml-2">{{'pie' | translate}}</label>
            </div>
            <div class="col-12 flex items-center">
              <p-radioButton
                name="group11"
                value="line"
                [(ngModel)]="chartType"
                inputId="opt31"
              ></p-radioButton>
              <label for="opt31" class="ml-2">{{'line' | translate}}</label>
            </div>
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <div class="col-12 flex items-center">
              <p-radioButton
                name="group1"
                value="year"
                [(ngModel)]="statType"
                inputId="opt1"
              ></p-radioButton>
              <label for="opt1" class="ml-2">{{'year' | translate}}</label>
            </div>
            <div class="col-12 flex items-center">
              <p-radioButton
                name="group1"
                value="month"
                [(ngModel)]="statType"
                inputId="opt2"
              ></p-radioButton>
              <label for="opt2" class="ml-2">{{'month' | translate}}</label>
            </div>
              <div class="col-12 flex items-center">
                <p-radioButton
                  name="group1"
                  value="day"
                  [(ngModel)]="statType"
                  inputId="opt3"
                ></p-radioButton>
                <label for="opt3" class="ml-2">{{'day' | translate}}</label>
              </div>
              @if (statType === 'day') {
                <div class="col-12">
                  <div class="col-11">
                    <p-slider [(ngModel)]="nbDays" [min]="7" [max]="15"> >{{ nbDays }}</p-slider>
                  </div>
                  <div class="col-1">
                    <span class="marginday">{{ nbDays }}</span>
                  </div>
                </div>
              }
          </div>
          <div class="col-12 md:col-6 lg:col-4">
            <button class="right" type="text" pButton label="{{'Apply' | translate}}" (click)="onClickRb()"></button>
          </div>
        </div>
      </p-overlayPanel>
    </div>
    @if (chartType !== 'line') {
      <div class="col-12 align">{{'Tot' | translate}}  {{ totalDoc }}</div>
    }
    <p-chart [type]="chartType" [data]="dataStat" width="100%" height="400px"></p-chart>
}
